// src/utils/http.js
import axios from 'axios';
import { ElMessage } from "element-plus";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
});

// 错误拦截器
service.interceptors.response.use(
  response => response,
  error => {
    console.log("错误信息"+error);
    if (error.code === 'ECONNABORTED') {
      ElMessage.error('网络请求超时，请检查网络连接');
    } else {
      ElMessage.error('系统异常，请联系管理员'+error.message);
    }
    return Promise.reject(error);
  }
);

const _Native = {
  async getToken() {
    const url = '/session/create';
    const reqBodyMap = new Map();
    return service({
      url,
      method: 'post',
      data: reqBodyMap,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  },
  async request(url, body) {
    if (!body) {
      body = {};
    }
    body = Object.assign({ reqHead: {}, reqBody: {} }, body);

    let token1 = localStorage.getItem("token") || '';

    if (!token1) {
      let rspBody = await this.getToken();
      token1 = rspBody.data.rspBody.token;
      localStorage.setItem("token", token1);
    }
    body.reqHead = Object.assign(body.reqHead, {
      token: token1
    });
    return service({
      url,
      method: 'post',
      data: body,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}


export default _Native; // 导出axios实例，供其他地方调用